// @mui
import { esES } from '@mui/x-data-grid/locales';
// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_API_HOST || '';
export const PAYMENTS_HOST_API = process.env.REACT_APP_PAYMENTS_API_HOST || '';
export const CLC_HOST_API = process.env.REACT_APP_CLC_API || '';
export const ORIGINATION_HOST_API = process.env.REACT_APP_ORIGINATION_API_HOST || PAYMENTS_HOST_API;
export const PROSCAI_REPORTS_API_URL = process.env.REACT_APP_PROSCAI_REPORTS_API_URL || '';
export const CHATBOT_HOST_API = process.env.REACT_APP_CHATBOT_API || '';
export const CHATBOT_API_KEY = process.env.REACT_APP_CHATBOT_TOKEN || '';
export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API || '';
export const APP_NAME = process.env.REACT_APP_NAME || 'Colectivo Moda';
export const LOGIN_IMAGE = process.env.REACT_APP_LOGIN_IMAGE || '/assets/illustrations/illustration_register.png';
export const APP_LOGO = process.env.REACT_APP_LOGO || '';
export const EVENTS_WEBSITE = process.env.REACT_APP_EVENTS_WEBSITE || '';
export const BILLING_WEBSITE = process.env.REACT_APP_BILLING_WEBSITE || '';
export const RISK_API_URL = process.env.REACT_APP_RISK_API_URL || 'http://localhost:3000/api/v1/riskengine';
export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.controlTable.approvals;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 36,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: esES,
    icon: '/assets/icons/flags/ic_flag_us.svg',
  },
  {
    label: 'Español',
    value: 'es',
    systemValue: esES,
    icon: '/assets/icons/flags/ic_flag_mx.svg',
  },
];

export const defaultLang = allLangs[1]; // Spanish
